import { TypeAnimation } from 'react-type-animation'

const HHeader = () => {
    return (
        <div className="relative w-full h-screen bg-[#08362E] pt-[100px] max-lg:h-auto overflow-hidden">
            <div className="absolute inset-0 flex justify-center items-start pt-44 max-lg:pt-[140px] max-md:pt-32 max-sm:pt-[118px] z-10">
                <h1>
                    <TypeAnimation
                        className="text-[#08362E] tracking-[5px] max-sm:tracking-[3px] font-bold leading-none text-4xl max-lg:text-3xl max-md:text-xl max-sm:text-sm text-center"
                        style={{ fontFamily: 'seaons-reg' }}
                        sequence={[
                            `ONE VISION, MANY LANDMARKS`,
                            10000
                        ]}
                        speed={300}
                        cursor={false}
                    />
                </h1>
            </div>
            <img
                src='/HomePhotos/Header/hheader.webp'
                alt="homeheader"
                className="w-full h-full object-cover object-center"
            />
        </div>
    )
}

export default HHeader